
import { Placement } from '@post-office/placements-frontend/jira-issue-view-project-plan-twc-onboarding';
export default Placement;
